import { useTranslation } from "react-i18next";
import { logCTA } from "../../services/firebase/analytics";
import "./EcardSection.scss";

const ECARD_LANDING_URL = "https://ecard.effai.it/landing";
const ECARD_REGISTER_URL = "https://ecard.effai.it/register";
const APP_STORE_URL = "https://apps.apple.com/it/app/ecard/id6756520426";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.simone.digitalcard&pcampaignid=web_share";

export const EcardSection = () => {
  const { t } = useTranslation();

  const stats = t("landing:ecard.stats", { returnObjects: true }) as Array<{
    value: string;
    label: string;
  }>;

  const onCtaClick = () => {
    logCTA("ecard_landing", "ecard_section", { url: ECARD_LANDING_URL });
    window.open(ECARD_LANDING_URL, "_blank", "noopener,noreferrer");
  };

  const onLinkClick = (name: string, url: string) => {
    logCTA(name, "ecard_section", { url });
  };

  return (
    <section className="ecard__section" id="ecard">
      {/* Stessa decorazione della landing ECard */}
      <div className="ecard__bg-top" aria-hidden>
        <img src="/assets/ecard/background-top.png" alt="" />
      </div>
      <div className="ecard__bg-bottom" aria-hidden>
        <img src="/assets/ecard/background_bottom.png" alt="" />
      </div>
      <div className="ecard__blob ecard__blob--1" aria-hidden />
      <div className="ecard__blob ecard__blob--2" aria-hidden />

      <div className="ecard__inner">
        {/* Badge regalo */}
        <div className="ecard__badge">
          <i className="fas fa-gift" />
          <span>{t("landing:ecard.badge")}</span>
        </div>

        {/* Logo */}
        <div className="ecard__logo-wrap">
          <img
            src="/assets/ecard/Ecard-logo-nobackground.png"
            alt="ECard"
            className="ecard__logo"
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* Headline — stesso stile hero della landing ECard */}
        <h2 className="ecard__title">
          {t("landing:ecard.titleLine1")}
          <span className="ecard__title-gradient">
            {t("landing:ecard.titleLine2")}
          </span>
        </h2>

        <p className="ecard__subtitle">{t("landing:ecard.subtitle")}</p>

        {/* Stats — glassmorphism identico alle stat cards della landing */}
        <div className="ecard__stats">
          {stats.map((stat, i) => (
            <div key={i} className="ecard__stat-card">
              <div className="ecard__stat-glow" aria-hidden />
              <span className="ecard__stat-value">{stat.value}</span>
              <p className="ecard__stat-label">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Origin story — accento teal come sulla landing */}
        <p
          className="ecard__origin"
          dangerouslySetInnerHTML={{ __html: t("landing:ecard.origin") }}
        />

        {/* CTA principale */}
        <button className="ecard__cta-btn" onClick={onCtaClick} type="button">
          <span>{t("landing:ecard.cta")}</span>
          <i className="fas fa-arrow-right" aria-hidden />
        </button>

        <p className="ecard__cta-note">{t("landing:ecard.ctaNote")}</p>

        {/* Link secondari piccoli */}
        <nav className="ecard__links" aria-label="Accesso ECard">
          <a
            href={ECARD_REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onLinkClick("ecard_web_register", ECARD_REGISTER_URL)}
          >
            <i className="fas fa-globe" />
            {t("landing:ecard.linkWeb")}
          </a>
          <span aria-hidden>·</span>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onLinkClick("ecard_app_store", APP_STORE_URL)}
          >
            <i className="fab fa-apple" />
            {t("landing:ecard.linkAppStore")}
          </a>
          <span aria-hidden>·</span>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onLinkClick("ecard_play_store", PLAY_STORE_URL)}
          >
            <i className="fab fa-google-play" />
            {t("landing:ecard.linkPlay")}
          </a>
        </nav>
      </div>
    </section>
  );
};
